// extracted by mini-css-extract-plugin
export default {"viewport":"MarqueeTitle_viewport__UrYBy","track":"MarqueeTitle_track__KHOFq","overflow":"MarqueeTitle_overflow__mZ6C5","active":"MarqueeTitle_active__Z9gN1"};